import CurrentUser from './CurrentUser'

export default class ProfilePolicy {
  static can (action, account = false) {
    // Get current user
    const currentUser = new CurrentUser()
    const isUser = currentUser.access === 'User'
    // Evaluate action
    switch (action) {
      // Index
      case 'index':
        return !isUser
      // Read
      case 'read':
        return !isUser
      // Update
      case 'edit':
        return !isUser
      // Not allowed
      case 'add':
      case 'remove':
      default:
        return false
    }
  }
}



// WEBPACK FOOTER //
// ./src/policy/AccountPolicy.js